import React from 'react';
import Autocomplete from '@material-ui/lab/Autocomplete';
import { makeStyles } from '@material-ui/core/styles';
import TextField from '@material-ui/core/TextField';

const useStyles = makeStyles((theme) => ({
  autocompleteWrapper: {
    '& .MuiAutocomplete-inputRoot': {
      padding: '7px 50px 8px 15px !important',
    },
    '& .MuiAutocomplete-option': {
        backgroundColor: 'red',
    },
    '& .MuiAutocomplete-endAdornment': {
      top: 'calc(50% - 15px)',
      '& svg': {
        width: '22px !important',
        height: '22px !important',
      },
    },
  },
}));

const SelectMultiple = (props) => {
  const classes = useStyles();

  return (
    <div className={classes.root}>
      <Autocomplete
        className={classes.autocompleteWrapper}
        multiple
        renderInput={(params) => (
          <TextField
            label={props.label}
            {...params}
            InputLabelProps={{ shrink: true }}
          />
        )}
        {...props}
        onChange={(_, value) => {
          props.onChange({
            currentTarget: {
              name: props.name,
              value: value,
            },
          });
        }}
      />
    </div>
  );
};

export default SelectMultiple;